import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  imageAlt: {
    id: 'catalog.marketing-course-card.image-alt',
    defaultMessage: 'Course illustration for {courseName}',
    description: 'Alternative text for a course card image.',
  },
  defaultTitle: {
    id: 'catalog.marketing-course-card.default-title',
    defaultMessage: 'Loading course',
    description: 'Fallback title while a course card is loading.',
  },
  viewCourse: {
    id: 'catalog.marketing-course-card.view-course',
    defaultMessage: 'View course',
    description: 'CTA label on a marketing course card.',
  },
});

export default messages;
